var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg41(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 1C11.0742 1 1 11.0742 1 23.5C1 35.9258 11.0746 46 23.5 46C35.9254 46 46 35.9286 46 23.5C46 11.0715 35.9272 1 23.5 1Z",
    fill: "#53AE94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7231 20.5021V17.155H13.069V12.0552H33.9112V17.155H26.2563V20.4994C32.4775 20.7852 37.1553 22.0173 37.1553 23.4933C37.1553 24.9693 32.4753 26.2014 26.2563 26.4889V37.2102H20.7213V26.488C14.5113 26.2014 9.84297 24.9702 9.84297 23.4955C9.84297 22.0209 14.5113 20.7897 20.7213 20.503L20.7231 20.5021ZM20.7213 25.5799V25.5772C20.8774 25.5871 21.6798 25.6353 23.4663 25.6353C24.8946 25.6353 25.8994 25.5948 26.2536 25.5763V25.5808C31.7499 25.3374 35.8525 24.3802 35.8525 23.235C35.8525 22.0897 31.7494 21.1339 26.2536 20.89V24.6273C25.8936 24.652 24.864 24.7128 23.4429 24.7128C21.736 24.7128 20.8779 24.6417 20.7204 24.6273V20.89C15.2349 21.1344 11.1417 22.0924 11.1417 23.2336C11.1417 24.3748 15.2367 25.3333 20.7204 25.5777",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg41);
export default __webpack_public_path__ + "static/media/41.e8e974063e1e32d0b2bb399bb36322e3.svg";
export { ForwardRef as ReactComponent };